import React from "react";
import AdvanceTip from "../utility/advance-tip";
import { browserHistory } from "react-router";
import * as authAction from "../../actions/auth-action";
import authStore from "../../store/auth-store";
import User from "../../../models/user.js";
import Spinner from "../utility/spinner";


export default class Login extends React.Component {
    constructor() {
        super();
        this.state = {
            loginFailed: false,
            passwordForget: false,
            invalidPasswordRecovery: false,
            invalidEmail: false,
            errorMsg: ""
        };
        this.afterLogIn = this.afterLogIn.bind(this);
        this.onlogInFailed = this.onlogInFailed.bind(this);
        this.onPasswordRecovered = this.onPasswordRecovered.bind(this);
        this.onPasswordRecoveryFailed = this.onPasswordRecoveryFailed.bind(this);
        this.spinner = null;
        this.handleLogin = this.handleLogin.bind(this);
    }



    handleLogin() {
        // this.state.loginFailed = true;
        // this.setState(this.state);
        const email = this.refs.email.value;
        const password = this.refs.password.value;
        if (User.validateEmail(email) && User.validatePassword(password)) {
            authAction.login(email, password);
            this.spinner = <Spinner></Spinner>;
            this.forceUpdate();

        } else {
            this.setState({ loginFailed: true });
        }


    }
    cancelTip() {
        this.setState({ loginFailed: false });
    }
    onPasswordForget() {
        this.setState({ passwordForget: true });
    }

    recoverPassword() {
        //alert("hello");
        if (User.validateEmail(this.refs.recoveryEmail.value)) {
            authAction.recoverPassword(this.refs.recoveryEmail.value);
            this.spinner = <Spinner></Spinner>;
            this.forceUpdate();
        } else {
            this.setState({ invalidPasswordRecovery: true });
        }


    }

    reset() {
        this.setState({
            loginFailed: false,
            passwordForget: false,
            invalidPasswordRecovery: false
        });
    }

    onlogInFailed() {
        this.spinner = null;
        this.setState({ loginFailed: true });
    }

    afterLogIn() {
        const location = this.props.pageProps.location;
        if (location.state && location.state.nextPathname) {
            browserHistory.push(location.state.nextPathname);
        } else {
            browserHistory.push("/");
        }
    }
    onPasswordRecovered() {
        alert("a password recovery email has been send to your mail address");
        window.location.reload();
        //console.log("ok");
    }

    onPasswordRecoveryFailed() {
        this.spinner = null;
        this.setState({ invalidPasswordRecovery: true });
    }

    componentWillMount() {
        authStore.on("loginSuccess", this.afterLogIn);
        authStore.on("loginFailed", this.onlogInFailed);
        authStore.on("passwordRecovered", this.onPasswordRecovered);
        authStore.on("passwordRecoveryFailed", this.onPasswordRecoveryFailed);
    }

    componentWillUnmount() {
        //console.log("component unmmout fired");
        authStore.removeListener("loginSuccess", this.afterLogIn);
        authStore.removeListener("loginFailed", this.onlogInFailed);
        authStore.removeListener("passwordRecovered", this.onPasswordRecovered);
        authStore.removeListener("passwordRecoveryFailed", this.onPasswordRecoveryFailed);

    }

    recoveryEmailOnKeyUp(e) {
        // this is to hide the tip this is not a registered emailid
        if (e.target.value === "") {
            this.setState({ invalidPasswordRecovery: false });
        }
    }
    handlePassword(event) {
        if (event.keyCode === 13) {
            this.handleLogin();
        }

    }
    render() {
        return (
            <div className="smallholder">
                <p className="formMsg">{!this.state.passwordForget ? "Login" : "Password recovery"}</p>
                {!this.state.passwordForget ?
                    <div>
                        <table className="formTable">
                            <tbody>
                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            className="formControl inputBox"
                                            placeholder="Email address"
                                            ref="email"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input
                                            type="password"
                                            className="formControl inputBox"
                                            placeholder="Password"
                                            ref="password"
                                            onKeyUp={this.handlePassword.bind(this)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <AdvanceTip
                                            showOn={this.state.loginFailed}
                                            tipStyle={{ left: "1px", top: "-20px", width: "250px", background: "#3c4d67", fontSize: "14px", textAlign: "left", lineHeight: "1.5em", height: "50px" }}
                                            pointerStyle={{}}
                                            pointerClass="tUpLeft"
                                            closeBtnStyle={{ position: "absolute", right: "8px" }}
                                            cancelTip={this.cancelTip.bind(this)}
                                        >
                                            <p style={{ color: "white" }}>Invalid email address or password !!!</p>
                                            <p onClick={this.onPasswordForget.bind(this)} style={{ color: "white", fontSize: "13px", textDecoration: "underline", cursor: "pointer" }}>Did you forget password ?</p>
                                        </AdvanceTip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button
                            className="btn btnOk btnRight"
                            onClick={this.handleLogin}
                        >
                            Login
                        </button>
                        <div className="clear"></div>

                    </div>
                    : (<div>
                        <table className="formTable">
                            <tbody>
                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            className="formControl inputBox"
                                            placeholder="Enter your Email address"
                                            ref="recoveryEmail"
                                            onKeyUp={this.recoveryEmailOnKeyUp.bind(this)}

                                        />
                                        <AdvanceTip
                                            showOn={this.state.invalidPasswordRecovery}
                                            tipStyle={{ left: "0", top: "40px", width: "250px", fontSize: "14px", textAlign: "left", lineHeight: "1.5em" }}
                                        >
                                            <p>This is not a registered email address !!!</p>

                                        </AdvanceTip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button
                            className="btn btnOk btnRight"
                            onClick={this.recoverPassword.bind(this)}
                        >
                            Submit
                        </button>
                        <button
                            className="btn btnOk btnRight"
                            onClick={this.reset.bind(this)}
                            style={{ marginRight: "10px" }}
                        >
                            Cancel
                        </button>
                        <div className="clear"></div>
                    </div>)
                }
                {this.spinner}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/login.jsx